/* Project Kennel: product page. Gallery thumbnails and the purchase-option toggle. */
(function () {
  if (window.KennelPdp) return; window.KennelPdp = true;
  function init(root) {
    var gal = root.querySelector('[data-kp-gallery]');
    if (gal && !gal.kp) {
      gal.kp = 1;
      var main = gal.querySelector('.kp-gal__main img'), btns = [].slice.call(gal.querySelectorAll('.kp-gal__thumbs button'));
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          if (!main) return;
          main.src = b.dataset.src; main.removeAttribute('srcset'); main.alt = b.dataset.alt || '';
          if (b.dataset.zoom) main.dataset.zoom = b.dataset.zoom;
          main.classList.toggle('is-pack', b.hasAttribute('data-pack'));
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
      });
      zoom(gal);
    }
    var form = root.querySelector('#kp-form');
    if (form && !form.kp) {
      form.kp = 1;
      var plan = form.querySelector('[data-kp-plan]'), opts = [].slice.call(form.querySelectorAll('[data-kp-opt]'));
      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          opts.forEach(function (x) { x.setAttribute('aria-checked', x === o ? 'true' : 'false'); });
          if (plan) plan.disabled = o.dataset.kpOpt !== 'sub';
        });
      });
    }
  }
  /* Hover zoom (desktop only), like Amazon: a lens on the photo and a magnified view over the buy box. */
  function zoom(gal) {
    var box = gal.querySelector('.kp-gal__main'), lens = gal.querySelector('.kp-zoom__lens');
    var grid = gal.parentNode, pane = grid && grid.querySelector('.kp-zoom__pane'), buy = grid && grid.querySelector('.kp-buy');
    if (!box || !lens || !pane || !buy || !window.matchMedia) return;
    var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1001px)');
    var Z = 2.6, on = false, src = '', hi = new Image();
    function img() { return box.querySelector('img'); }
    function rect(im) { // the photo's drawn area inside the img box (object-fit contain or cover)
      var r = im.getBoundingClientRect(), nw = im.naturalWidth || r.width, nh = im.naturalHeight || r.height;
      var fit = getComputedStyle(im).objectFit, sc = fit === 'cover' ? Math.max(r.width / nw, r.height / nh) : Math.min(r.width / nw, r.height / nh);
      var w = nw * sc, h = nh * sc, l = r.left + (r.width - w) / 2, t = r.top + (r.height - h) / 2;
      if (fit === 'cover') { l = Math.max(l, r.left); t = Math.max(t, r.top); w = Math.min(w, r.width); h = Math.min(h, r.height); }
      return { l: l, t: t, w: w, h: h, fw: nw * sc, fh: nh * sc, fl: r.left + (r.width - nw * sc) / 2, ft: r.top + (r.height - nh * sc) / 2 };
    }
    function hide() { on = false; lens.hidden = true; pane.hidden = true; box.classList.remove('is-zoom'); }
    function show(e) {
      var im = img(); if (!im || !mq.matches) return hide();
      var R = rect(im), x = e.clientX, y = e.clientY;
      if (x < R.l || x > R.l + R.w || y < R.t || y > R.t + R.h) return hide();
      var z = im.dataset.zoom || im.currentSrc || im.src;
      if (z !== src) { src = z; hi.src = z; pane.style.backgroundImage = 'url("' + z + '")'; }
      var g = grid.getBoundingClientRect(), b = buy.getBoundingClientRect(), m = box.getBoundingClientRect();
      pane.style.left = (b.left - g.left) + 'px'; pane.style.top = (m.top - g.top) + 'px';
      pane.style.width = b.width + 'px'; pane.style.height = m.height + 'px';
      var pw = b.width, ph = m.height, lw = Math.min(pw / Z, R.w), lh = Math.min(ph / Z, R.h);
      var cx = Math.min(Math.max(x, R.l + lw / 2), R.l + R.w - lw / 2), cy = Math.min(Math.max(y, R.t + lh / 2), R.t + R.h - lh / 2);
      lens.style.width = lw + 'px'; lens.style.height = lh + 'px';
      lens.style.left = (cx - lw / 2 - m.left) + 'px'; lens.style.top = (cy - lh / 2 - m.top) + 'px';
      var bw = R.fw * Z, bh = R.fh * Z;
      pane.style.backgroundSize = bw + 'px ' + bh + 'px';
      pane.style.backgroundPosition = (-((cx - R.fl) * Z - pw / 2)) + 'px ' + (-((cy - R.ft) * Z - ph / 2)) + 'px';
      if (!on) { on = true; lens.hidden = false; pane.hidden = false; box.classList.add('is-zoom'); }
    }
    box.addEventListener('mousemove', show);
    box.addEventListener('mouseleave', hide);
    window.addEventListener('scroll', hide, { passive: true });
  }
  function boot() { try { init(document); } catch (e) { if (window.console) console.error('[kennel-pdp]', e); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { try { init(e.target); } catch (x) {} });
})();
/* "Write the first review": scroll to the Yotpo widget and open its form */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('[data-kp-write]'); if (!a) return;
  var box = document.getElementById('kp-all-reviews'); if (!box) return;
  e.preventDefault(); box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  setTimeout(function () {
    var b = box.querySelector('.yotpo-new-review-btn, .yotpo-write-first-review-button, .yotpo-first-review-button, [class*="write-review"] button, button[class*="first-review"]');
    if (b) b.click();
  }, 700);
});
